import React, { FC } from 'react';
import styled from 'styled-components';
import Button from '^/components/atoms/Button';
import { useL10n } from '^/hooks';
import Text from './text';
import theme from '^/theme';
import CloseIcon from '^/assets/icons/close.svg';
import { usePopupStore } from '^/store/popup';
import * as T from '^/types';
const SelectedMembersWrapper = styled.div({
  position: 'fixed',
  left: '50%',
  bottom: '20px',
  transform: 'translateX(-50%)',
  borderRadius: '8px',
  gap: '16px',
  backgroundColor: theme.colorTokens.accentBlue,
  padding: '16px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  zIndex: 99,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const SelectedCount = styled.span({
  fontWeight: 500,
  color: theme.colors.white[100],
});

const ActionButtons = styled.div({
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
});

const CloseButton = styled.button({
  background: 'none',
  border: 'none',
  padding: '4px',
  height: '24px',
  width: '24px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '12px',

  '&:hover': {
    opacity: 0.8,
  },
  '> svg > path': {
    fill: theme.colors.white[100],
  },
});

const buttonCustomStyle = {
  whiteSpace: 'nowrap',
};

interface Props {
  selectedCount: number;
  onClose(): void;
  isEssEnabled: boolean;
}

const ManageProjectBar: FC<Props> = ({ selectedCount, onClose, isEssEnabled }) => {
  const setPopupOptions = usePopupStore(s => s.setPopupOptions);
  const setMinorPopup = usePopupStore(s => s.setMinorPopup);
  const [l10n] = useL10n();

  const onClickHandler = (type: T.ManageProjectPopupType) => {
    setPopupOptions({ manageProjectPopupType: type });
    setMinorPopup(T.ContentPageMinorPopupType.MANAGE_PROJECT_POPUP);
  };

  return (
    <>
      <SelectedMembersWrapper data-testid="manage-project-bar">
        <SelectedCount data-testid={`selected-count-${selectedCount}`}>
          {selectedCount} {l10n(Text.selectedCollaborators)}
        </SelectedCount>
        <ActionButtons data-testid="manage-project-bar-action-buttons">
          <Button
            data-testid="change-roles-button"
            onClick={() => onClickHandler(T.ManageProjectPopupType.CHANGE_ROLE)}
            variant="secondary"
            customStyles={buttonCustomStyle}
          >
            {l10n(Text.changeRoles)}
          </Button>
          {isEssEnabled && (
            <Button
              data-testid="enable-disable-ess-button"
              onClick={() => onClickHandler(T.ManageProjectPopupType.CHANGE_SITE_LOGISTICS)}
              variant="secondary"
              customStyles={buttonCustomStyle}
            >
              {l10n(Text.enableDisableSiteLogistics)}
            </Button>
          )}
          <Button
            data-testid="remove-collaborators-button"
            onClick={() => onClickHandler(T.ManageProjectPopupType.REMOVE_COLLABORATORS)}
            variant="secondary"
            customStyles={buttonCustomStyle}
          >
            {l10n(Text.remove)}
          </Button>
          <CloseButton
            data-testid="close-manage-project-bar-button"
            onClick={onClose}
            title={l10n(Text.close)}
          >
            <CloseIcon />
          </CloseButton>
        </ActionButtons>
      </SelectedMembersWrapper>
    </>
  );
};

export default ManageProjectBar;
